import React, { FC, memo } from 'react';
import { OrderVariant } from '~/lib/data-contract/auto-generated/customer-model';
import { Typography } from '~/shared/components';
import styles from './product.module.css';
import ReturnIcon from '$icons/return.svg';
import ProductImage from '~/shared/components/product-image/product-image.component';
import { useTranslation } from '~/shared/utils';

type Props = {
    product: OrderVariant;
};

const Product: FC<Props> = memo(({ product }) => {
    const { translate } = useTranslation();
    if (!product) return null;

    const { productId, title, color, size, quantity, displayPrice, purchaseStatus } = product;

    const isRefunded = purchaseStatus === 'Refunded';

    return (
        <div>
            <div className={styles.root}>

                <ProductImage
                    skipImageOptimization
                    className={styles.productImage}
                    image={product.image ? { url: product.image } : undefined}
                    sizes={`120px`}
                    alt={product.title || 'Product image'}
                    width={120}
                    height={133}
                />
                <div className={styles.productInfo}>
                    <Typography variant="caption" as="div">
                        {translate('club.orderHistory.productId')}: {productId}
                    </Typography>
                    <Typography variant="bodySm" as="div">
                        {title}
                    </Typography>
                    <Typography variant="caption" as="div">
                        {color} {size && `- ${size}`}
                    </Typography>
                    <div className={styles.bottomSection}>
                        <div>
                            <Typography variant="caption" as="div">
                                {translate('club.orderHistory.quantity')}: {quantity}
                            </Typography>
                            {isRefunded && (
                            <div className={styles.refundedStatus}>
                                <ReturnIcon />
                                <Typography
                                    variant="bodyXs"
                                    as="span"
                                    fontWeight="medium"
                                >
                                    {translate('club.orderHistory.refunded')}
                                </Typography>
                            </div>
                            )} 
                        </div>
                        <Typography variant="bodyLg" as="span" fontWeight="bold">
                            {displayPrice}
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
});

Product.displayName = 'Product';
export default Product;
